// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body#portal .pdfModal .modal-footer.pdf-modal-footer[data-v-7921308d] {
  margin-top: 20px;
}
.modal-body[data-v-7921308d] {
  max-height: 600px;
  overflow-y: scroll;
  text-align: center;
  padding-top: 10px;
  margin: 0;
}
.spinner-margin[data-v-7921308d] {
  margin-top: 30%;
}
`, "",{"version":3,"sources":["webpack://./src/js/netpify/components/np-pdf-modal.vue","webpack://./np-pdf-modal.vue"],"names":[],"mappings":"AACI;EACI,gBAAA;ACAR;ADEI;EACI,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;ACAR;ADEI;EACI,eAAA;ACAR","sourcesContent":["\n    body#portal .pdfModal .modal-footer.pdf-modal-footer {\n        margin-top: 20px;\n    }\n    .modal-body {\n        max-height: 600px;\n        overflow-y: scroll;\n        text-align: center;\n        padding-top: 10px;\n        margin: 0;\n    }\n    .spinner-margin {\n        margin-top: 30%;\n    }\n","body#portal .pdfModal .modal-footer.pdf-modal-footer {\n  margin-top: 20px;\n}\n.modal-body {\n  max-height: 600px;\n  overflow-y: scroll;\n  text-align: center;\n  padding-top: 10px;\n  margin: 0;\n}\n.spinner-margin {\n  margin-top: 30%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
